import { Link } from 'react-router-dom';
import { useReveal } from '../../hooks/useReveal';

interface CTAProps {
  title: React.ReactNode;
  description: string;
  stats?: { number: string; label: string }[];
  primaryBtn: { text: string; link: string; icon?: string };
  secondaryBtn?: { text: string; link: string; icon?: string };
  gradient?: string;
}

export default function CTA({ 
  title, 
  description, 
  stats, 
  primaryBtn, 
  secondaryBtn,
  gradient = "from-purple-900 via-black to-pink-900"
}: CTAProps) {
  const { isVisible, ref } = useReveal(0.2);

  return (
    <section ref={ref as any} className={`relative py-20 bg-gradient-to-br ${gradient} overflow-hidden`}>
      <div className={`relative z-10 max-w-6xl mx-auto px-6 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {stats && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            {stats.map((stat, index) => (
              <div key={index} className="text-center group">
                <div className="text-3xl font-bold text-white mb-2">{stat.number}</div>
                <div className="text-gray-300 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        )}

        <h2 className="text-4xl md:text-6xl font-bold mb-6 leading-tight text-white">
          {title}
        </h2>
        
        <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-4xl mx-auto leading-relaxed">
          {description}
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <Link to={primaryBtn.link} className="btn-primary">
            {primaryBtn.icon && <i className={`${primaryBtn.icon} mr-2`}></i>}
            {primaryBtn.text}
          </Link>
          {secondaryBtn && (
            <Link to={secondaryBtn.link} className="btn-secondary">
              {secondaryBtn.icon && <i className={`${secondaryBtn.icon} mr-2`}></i>}
              {secondaryBtn.text}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}